// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as ByggeledelseRouteImport } from './routes/byggeledelse'
import { Route as BygherreraadgivningRouteImport } from './routes/bygherreraadgivning'
import { Route as CookieOgPrivatlivspolitikRouteImport } from './routes/cookie-og-privatlivspolitik'
import { Route as EsgRouteImport } from './routes/esg'
import { Route as GratisSikkerhedstjekLandingRouteImport } from './routes/gratis-sikkerhedstjek-landing'
import { Route as HseLedelseRouteImport } from './routes/hse-ledelse'
import { Route as KarriereRouteImport } from './routes/karriere'
import { Route as KontaktRouteImport } from './routes/kontakt'
import { Route as KontaktMiSupportRouteImport } from './routes/kontakt-mi-support'
import { Route as MiSupportLogoRouteImport } from './routes/mi-support-logo'
import { Route as MiSupportSomArbejdspladsRouteImport } from './routes/mi-support-som-arbejdsplads'
import { Route as ModDanRouteImport } from './routes/mod-dan'
import { Route as ModDanielRouteImport } from './routes/mod-daniel'
import { Route as ModEnMiSupporterRouteImport } from './routes/mod-en-mi-supporter'
import { Route as ModMaleneRouteImport } from './routes/mod-malene'
import { Route as ModNoreenThomasRouteImport } from './routes/mod-noreen-thomas'
import { Route as MoedChristianRouteImport } from './routes/moed-christian'
import { Route as MoedEstherRouteImport } from './routes/moed-esther'
import { Route as MoedMajaRouteImport } from './routes/moed-maja'
import { Route as MoedTokeRouteImport } from './routes/moed-toke'
import { Route as OmOsRouteImport } from './routes/om-os'
import { Route as PersondatapolitikRouteImport } from './routes/persondatapolitik'
import { Route as ProjektassistanceRouteImport } from './routes/projektassistance'
import { Route as ProjektledelseRouteImport } from './routes/projektledelse'
import { Route as ProjektoekonomiRouteImport } from './routes/projektoekonomi'
import { Route as SamarbejdspartnereRouteImport } from './routes/samarbejdspartnere'
import { Route as ShutdownPlanlaegningRouteImport } from './routes/shutdown-planlaegning'
import { Route as SikkerhedsledelseHseRouteImport } from './routes/sikkerhedsledelse-hse'
import { Route as SitecomplianceRouteImport } from './routes/sitecompliance'
import { Route as TidsplanlaegningRouteImport } from './routes/tidsplanlaegning'
import { Route as YdelserRouteImport } from './routes/ydelser'
import { Route as ArtiklerIndexRouteImport } from './routes/artikler.index'
import { Route as ArtiklerSlugRouteImport } from './routes/artikler.$slug'
import { Route as BrancherIndexRouteImport } from './routes/brancher.index'
import { Route as BrancherDatacentreRouteImport } from './routes/brancher.datacentre'
import { Route as BrancherEnergiInfrastrukturRouteImport } from './routes/brancher.energi-infrastruktur'
import { Route as BrancherHospitalerSundhedRouteImport } from './routes/brancher.hospitaler-sundhed'
import { Route as BrancherIndustriProduktionRouteImport } from './routes/brancher.industri-produktion'
import { Route as BrancherKontorHovedsaederRouteImport } from './routes/brancher.kontor-hovedsaeder'
import { Route as BrancherPharmaLifeScienceRouteImport } from './routes/brancher.pharma-life-science'
import { Route as BrancherTransportLogistikRouteImport } from './routes/brancher.transport-logistik'
import { Route as DeIndexRouteImport } from './routes/de/index'
import { Route as DeBauherrenberatungRouteImport } from './routes/de/bauherrenberatung'
import { Route as DeBaumanagementRouteImport } from './routes/de/baumanagement'
import { Route as DeCookieUndDatenschutzrichtlinieRouteImport } from './routes/de/cookie-und-datenschutzrichtlinie'
import { Route as DeDatenschutzbestimmungenRouteImport } from './routes/de/datenschutzbestimmungen'
import { Route as DeEsgRouteImport } from './routes/de/esg'
import { Route as DeGegenDieseRouteImport } from './routes/de/gegen-diese'
import { Route as DeGegenNoreenThomasRouteImport } from './routes/de/gegen-noreen-thomas'
import { Route as DeGegenuberDanielRouteImport } from './routes/de/gegenuber-daniel'
import { Route as DeGegenuberEinemMitstreiterRouteImport } from './routes/de/gegenuber-einem-mitstreiter'
import { Route as DeGegenuberMaleneRouteImport } from './routes/de/gegenuber-malene'
import { Route as DeGeschaftspartnerRouteImport } from './routes/de/geschaftspartner'
import { Route as DeHseManagementRouteImport } from './routes/de/hse-management'
import { Route as DeKarriereRouteImport } from './routes/de/karriere'
import { Route as DeKontaktMiSupportRouteImport } from './routes/de/kontakt-mi-support'
import { Route as DeLeistungenRouteImport } from './routes/de/leistungen'
import { Route as DeMiSupportLogoRouteImport } from './routes/de/mi-support-logo'
import { Route as DeMiUnterstutzungAlsArbeitsplatzRouteImport } from './routes/de/mi-unterstutzung-als-arbeitsplatz'
import { Route as DeMoedEstherRouteImport } from './routes/de/moed-esther'
import { Route as DeMoedMajaRouteImport } from './routes/de/moed-maja'
import { Route as DeMoedTokeRouteImport } from './routes/de/moed-toke'
import { Route as DeMutigerChristRouteImport } from './routes/de/mutiger-christ'
import { Route as DeProjektassistenzRouteImport } from './routes/de/projektassistenz'
import { Route as DeProjektleitungRouteImport } from './routes/de/projektleitung'
import { Route as DeProjektoekonomieRouteImport } from './routes/de/projektoekonomie'
import { Route as DeShutdownPlanungRouteImport } from './routes/de/shutdown-planung'
import { Route as DeTerminplanungRouteImport } from './routes/de/terminplanung'
import { Route as DeUberUnsRouteImport } from './routes/de/uber-uns'
import { Route as EnIndexRouteImport } from './routes/en/index'
import { Route as EnAboutUsRouteImport } from './routes/en/about-us'
import { Route as EnBusinessPartnersRouteImport } from './routes/en/business-partners'
import { Route as EnCareersRouteImport } from './routes/en/careers'
import { Route as EnClientConsultancyRouteImport } from './routes/en/client-consultancy'
import { Route as EnConstructionManagementRouteImport } from './routes/en/construction-management'
import { Route as EnContactMiSupportRouteImport } from './routes/en/contact-mi-support'
import { Route as EnCookieAndPrivacyPolicyRouteImport } from './routes/en/cookie-and-privacy-policy'
import { Route as EnDatapolicyRouteImport } from './routes/en/datapolicy'
import { Route as EnEsgRouteImport } from './routes/en/esg'
import { Route as EnHseManagementRouteImport } from './routes/en/hse-management'
import { Route as EnMeetAMiSupporterRouteImport } from './routes/en/meet-a-mi-supporter'
import { Route as EnMeetChristianRouteImport } from './routes/en/meet-christian'
import { Route as EnMeetDanRouteImport } from './routes/en/meet-dan'
import { Route as EnMeetDanielRouteImport } from './routes/en/meet-daniel'
import { Route as EnMeetMaleneRouteImport } from './routes/en/meet-malene'
import { Route as EnMeetNoreenThomasRouteImport } from './routes/en/meet-noreen-thomas'
import { Route as EnMiSupportAsAWorkplaceRouteImport } from './routes/en/mi-support-as-a-workplace'
import { Route as EnMiSupportLogoRouteImport } from './routes/en/mi-support-logo'
import { Route as EnMoedEstherRouteImport } from './routes/en/moed-esther'
import { Route as EnMoedMajaRouteImport } from './routes/en/moed-maja'
import { Route as EnMoedTokeRouteImport } from './routes/en/moed-toke'
import { Route as EnProjectAssistanceRouteImport } from './routes/en/project-assistance'
import { Route as EnProjectEconomicsRouteImport } from './routes/en/project-economics'
import { Route as EnProjectManagementRouteImport } from './routes/en/project-management'
import { Route as EnSchedulingRouteImport } from './routes/en/scheduling'
import { Route as EnServicesRouteImport } from './routes/en/services'
import { Route as EnShutdownPlanningRouteImport } from './routes/en/shutdown-planning'
import { Route as VidenIndexRouteImport } from './routes/viden.index'
import { Route as VidenSlugRouteImport } from './routes/viden.$slug'
import { Route as DeArtikelIndexRouteImport } from './routes/de/artikel.index'
import { Route as DeArtikelSlugRouteImport } from './routes/de/artikel.$slug'
import { Route as DeBranchenIndexRouteImport } from './routes/de/branchen.index'
import { Route as DeBranchenBuerosHauptsitzeRouteImport } from './routes/de/branchen.bueros-hauptsitze'
import { Route as DeBranchenEnergieInfrastrukturRouteImport } from './routes/de/branchen.energie-infrastruktur'
import { Route as DeBranchenIndustrieProduktionRouteImport } from './routes/de/branchen.industrie-produktion'
import { Route as DeBranchenKrankenhaeuserGesundheitRouteImport } from './routes/de/branchen.krankenhaeuser-gesundheit'
import { Route as DeBranchenPharmaLifeScienceRouteImport } from './routes/de/branchen.pharma-life-science'
import { Route as DeBranchenRechenzentrenRouteImport } from './routes/de/branchen.rechenzentren'
import { Route as DeBranchenTransportLogistikRouteImport } from './routes/de/branchen.transport-logistik'
import { Route as EnArticlesIndexRouteImport } from './routes/en/articles.index'
import { Route as EnArticlesSlugRouteImport } from './routes/en/articles.$slug'
import { Route as EnIndustriesIndexRouteImport } from './routes/en/industries.index'
import { Route as EnIndustriesDataCentersRouteImport } from './routes/en/industries.data-centers'
import { Route as EnIndustriesEnergyInfrastructureRouteImport } from './routes/en/industries.energy-infrastructure'
import { Route as EnIndustriesHospitalsHealthcareRouteImport } from './routes/en/industries.hospitals-healthcare'
import { Route as EnIndustriesIndustryManufacturingRouteImport } from './routes/en/industries.industry-manufacturing'
import { Route as EnIndustriesOfficesHeadquartersRouteImport } from './routes/en/industries.offices-headquarters'
import { Route as EnIndustriesPharmaLifeScienceRouteImport } from './routes/en/industries.pharma-life-science'
import { Route as EnIndustriesTransportLogisticsRouteImport } from './routes/en/industries.transport-logistics'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AnalyticsRoute = AnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => rootRouteImport
          })
const ByggeledelseRoute = ByggeledelseRouteImport.update({
            id: '/byggeledelse',path: '/byggeledelse',getParentRoute: () => rootRouteImport
          })
const BygherreraadgivningRoute = BygherreraadgivningRouteImport.update({
            id: '/bygherreraadgivning',path: '/bygherreraadgivning',getParentRoute: () => rootRouteImport
          })
const CookieOgPrivatlivspolitikRoute = CookieOgPrivatlivspolitikRouteImport.update({
            id: '/cookie-og-privatlivspolitik',path: '/cookie-og-privatlivspolitik',getParentRoute: () => rootRouteImport
          })
const EsgRoute = EsgRouteImport.update({
            id: '/esg',path: '/esg',getParentRoute: () => rootRouteImport
          })
const GratisSikkerhedstjekLandingRoute = GratisSikkerhedstjekLandingRouteImport.update({
            id: '/gratis-sikkerhedstjek-landing',path: '/gratis-sikkerhedstjek-landing',getParentRoute: () => rootRouteImport
          })
const HseLedelseRoute = HseLedelseRouteImport.update({
            id: '/hse-ledelse',path: '/hse-ledelse',getParentRoute: () => rootRouteImport
          })
const KarriereRoute = KarriereRouteImport.update({
            id: '/karriere',path: '/karriere',getParentRoute: () => rootRouteImport
          })
const KontaktRoute = KontaktRouteImport.update({
            id: '/kontakt',path: '/kontakt',getParentRoute: () => rootRouteImport
          })
const KontaktMiSupportRoute = KontaktMiSupportRouteImport.update({
            id: '/kontakt-mi-support',path: '/kontakt-mi-support',getParentRoute: () => rootRouteImport
          })
const MiSupportLogoRoute = MiSupportLogoRouteImport.update({
            id: '/mi-support-logo',path: '/mi-support-logo',getParentRoute: () => rootRouteImport
          })
const MiSupportSomArbejdspladsRoute = MiSupportSomArbejdspladsRouteImport.update({
            id: '/mi-support-som-arbejdsplads',path: '/mi-support-som-arbejdsplads',getParentRoute: () => rootRouteImport
          })
const ModDanRoute = ModDanRouteImport.update({
            id: '/mod-dan',path: '/mod-dan',getParentRoute: () => rootRouteImport
          })
const ModDanielRoute = ModDanielRouteImport.update({
            id: '/mod-daniel',path: '/mod-daniel',getParentRoute: () => rootRouteImport
          })
const ModEnMiSupporterRoute = ModEnMiSupporterRouteImport.update({
            id: '/mod-en-mi-supporter',path: '/mod-en-mi-supporter',getParentRoute: () => rootRouteImport
          })
const ModMaleneRoute = ModMaleneRouteImport.update({
            id: '/mod-malene',path: '/mod-malene',getParentRoute: () => rootRouteImport
          })
const ModNoreenThomasRoute = ModNoreenThomasRouteImport.update({
            id: '/mod-noreen-thomas',path: '/mod-noreen-thomas',getParentRoute: () => rootRouteImport
          })
const MoedChristianRoute = MoedChristianRouteImport.update({
            id: '/moed-christian',path: '/moed-christian',getParentRoute: () => rootRouteImport
          })
const MoedEstherRoute = MoedEstherRouteImport.update({
            id: '/moed-esther',path: '/moed-esther',getParentRoute: () => rootRouteImport
          })
const MoedMajaRoute = MoedMajaRouteImport.update({
            id: '/moed-maja',path: '/moed-maja',getParentRoute: () => rootRouteImport
          })
const MoedTokeRoute = MoedTokeRouteImport.update({
            id: '/moed-toke',path: '/moed-toke',getParentRoute: () => rootRouteImport
          })
const OmOsRoute = OmOsRouteImport.update({
            id: '/om-os',path: '/om-os',getParentRoute: () => rootRouteImport
          })
const PersondatapolitikRoute = PersondatapolitikRouteImport.update({
            id: '/persondatapolitik',path: '/persondatapolitik',getParentRoute: () => rootRouteImport
          })
const ProjektassistanceRoute = ProjektassistanceRouteImport.update({
            id: '/projektassistance',path: '/projektassistance',getParentRoute: () => rootRouteImport
          })
const ProjektledelseRoute = ProjektledelseRouteImport.update({
            id: '/projektledelse',path: '/projektledelse',getParentRoute: () => rootRouteImport
          })
const ProjektoekonomiRoute = ProjektoekonomiRouteImport.update({
            id: '/projektoekonomi',path: '/projektoekonomi',getParentRoute: () => rootRouteImport
          })
const SamarbejdspartnereRoute = SamarbejdspartnereRouteImport.update({
            id: '/samarbejdspartnere',path: '/samarbejdspartnere',getParentRoute: () => rootRouteImport
          })
const ShutdownPlanlaegningRoute = ShutdownPlanlaegningRouteImport.update({
            id: '/shutdown-planlaegning',path: '/shutdown-planlaegning',getParentRoute: () => rootRouteImport
          })
const SikkerhedsledelseHseRoute = SikkerhedsledelseHseRouteImport.update({
            id: '/sikkerhedsledelse-hse',path: '/sikkerhedsledelse-hse',getParentRoute: () => rootRouteImport
          })
const SitecomplianceRoute = SitecomplianceRouteImport.update({
            id: '/sitecompliance',path: '/sitecompliance',getParentRoute: () => rootRouteImport
          })
const TidsplanlaegningRoute = TidsplanlaegningRouteImport.update({
            id: '/tidsplanlaegning',path: '/tidsplanlaegning',getParentRoute: () => rootRouteImport
          })
const YdelserRoute = YdelserRouteImport.update({
            id: '/ydelser',path: '/ydelser',getParentRoute: () => rootRouteImport
          })
const ArtiklerIndexRoute = ArtiklerIndexRouteImport.update({
            id: '/artikler/',path: '/artikler/',getParentRoute: () => rootRouteImport
          })
const ArtiklerSlugRoute = ArtiklerSlugRouteImport.update({
            id: '/artikler/$slug',path: '/artikler/$slug',getParentRoute: () => rootRouteImport
          })
const BrancherIndexRoute = BrancherIndexRouteImport.update({
            id: '/brancher/',path: '/brancher/',getParentRoute: () => rootRouteImport
          })
const BrancherDatacentreRoute = BrancherDatacentreRouteImport.update({
            id: '/brancher/datacentre',path: '/brancher/datacentre',getParentRoute: () => rootRouteImport
          })
const BrancherEnergiInfrastrukturRoute = BrancherEnergiInfrastrukturRouteImport.update({
            id: '/brancher/energi-infrastruktur',path: '/brancher/energi-infrastruktur',getParentRoute: () => rootRouteImport
          })
const BrancherHospitalerSundhedRoute = BrancherHospitalerSundhedRouteImport.update({
            id: '/brancher/hospitaler-sundhed',path: '/brancher/hospitaler-sundhed',getParentRoute: () => rootRouteImport
          })
const BrancherIndustriProduktionRoute = BrancherIndustriProduktionRouteImport.update({
            id: '/brancher/industri-produktion',path: '/brancher/industri-produktion',getParentRoute: () => rootRouteImport
          })
const BrancherKontorHovedsaederRoute = BrancherKontorHovedsaederRouteImport.update({
            id: '/brancher/kontor-hovedsaeder',path: '/brancher/kontor-hovedsaeder',getParentRoute: () => rootRouteImport
          })
const BrancherPharmaLifeScienceRoute = BrancherPharmaLifeScienceRouteImport.update({
            id: '/brancher/pharma-life-science',path: '/brancher/pharma-life-science',getParentRoute: () => rootRouteImport
          })
const BrancherTransportLogistikRoute = BrancherTransportLogistikRouteImport.update({
            id: '/brancher/transport-logistik',path: '/brancher/transport-logistik',getParentRoute: () => rootRouteImport
          })
const DeIndexRoute = DeIndexRouteImport.update({
            id: '/de/',path: '/de/',getParentRoute: () => rootRouteImport
          })
const DeBauherrenberatungRoute = DeBauherrenberatungRouteImport.update({
            id: '/de/bauherrenberatung',path: '/de/bauherrenberatung',getParentRoute: () => rootRouteImport
          })
const DeBaumanagementRoute = DeBaumanagementRouteImport.update({
            id: '/de/baumanagement',path: '/de/baumanagement',getParentRoute: () => rootRouteImport
          })
const DeCookieUndDatenschutzrichtlinieRoute = DeCookieUndDatenschutzrichtlinieRouteImport.update({
            id: '/de/cookie-und-datenschutzrichtlinie',path: '/de/cookie-und-datenschutzrichtlinie',getParentRoute: () => rootRouteImport
          })
const DeDatenschutzbestimmungenRoute = DeDatenschutzbestimmungenRouteImport.update({
            id: '/de/datenschutzbestimmungen',path: '/de/datenschutzbestimmungen',getParentRoute: () => rootRouteImport
          })
const DeEsgRoute = DeEsgRouteImport.update({
            id: '/de/esg',path: '/de/esg',getParentRoute: () => rootRouteImport
          })
const DeGegenDieseRoute = DeGegenDieseRouteImport.update({
            id: '/de/gegen-diese',path: '/de/gegen-diese',getParentRoute: () => rootRouteImport
          })
const DeGegenNoreenThomasRoute = DeGegenNoreenThomasRouteImport.update({
            id: '/de/gegen-noreen-thomas',path: '/de/gegen-noreen-thomas',getParentRoute: () => rootRouteImport
          })
const DeGegenuberDanielRoute = DeGegenuberDanielRouteImport.update({
            id: '/de/gegenuber-daniel',path: '/de/gegenuber-daniel',getParentRoute: () => rootRouteImport
          })
const DeGegenuberEinemMitstreiterRoute = DeGegenuberEinemMitstreiterRouteImport.update({
            id: '/de/gegenuber-einem-mitstreiter',path: '/de/gegenuber-einem-mitstreiter',getParentRoute: () => rootRouteImport
          })
const DeGegenuberMaleneRoute = DeGegenuberMaleneRouteImport.update({
            id: '/de/gegenuber-malene',path: '/de/gegenuber-malene',getParentRoute: () => rootRouteImport
          })
const DeGeschaftspartnerRoute = DeGeschaftspartnerRouteImport.update({
            id: '/de/geschaftspartner',path: '/de/geschaftspartner',getParentRoute: () => rootRouteImport
          })
const DeHseManagementRoute = DeHseManagementRouteImport.update({
            id: '/de/hse-management',path: '/de/hse-management',getParentRoute: () => rootRouteImport
          })
const DeKarriereRoute = DeKarriereRouteImport.update({
            id: '/de/karriere',path: '/de/karriere',getParentRoute: () => rootRouteImport
          })
const DeKontaktMiSupportRoute = DeKontaktMiSupportRouteImport.update({
            id: '/de/kontakt-mi-support',path: '/de/kontakt-mi-support',getParentRoute: () => rootRouteImport
          })
const DeLeistungenRoute = DeLeistungenRouteImport.update({
            id: '/de/leistungen',path: '/de/leistungen',getParentRoute: () => rootRouteImport
          })
const DeMiSupportLogoRoute = DeMiSupportLogoRouteImport.update({
            id: '/de/mi-support-logo',path: '/de/mi-support-logo',getParentRoute: () => rootRouteImport
          })
const DeMiUnterstutzungAlsArbeitsplatzRoute = DeMiUnterstutzungAlsArbeitsplatzRouteImport.update({
            id: '/de/mi-unterstutzung-als-arbeitsplatz',path: '/de/mi-unterstutzung-als-arbeitsplatz',getParentRoute: () => rootRouteImport
          })
const DeMoedEstherRoute = DeMoedEstherRouteImport.update({
            id: '/de/moed-esther',path: '/de/moed-esther',getParentRoute: () => rootRouteImport
          })
const DeMoedMajaRoute = DeMoedMajaRouteImport.update({
            id: '/de/moed-maja',path: '/de/moed-maja',getParentRoute: () => rootRouteImport
          })
const DeMoedTokeRoute = DeMoedTokeRouteImport.update({
            id: '/de/moed-toke',path: '/de/moed-toke',getParentRoute: () => rootRouteImport
          })
const DeMutigerChristRoute = DeMutigerChristRouteImport.update({
            id: '/de/mutiger-christ',path: '/de/mutiger-christ',getParentRoute: () => rootRouteImport
          })
const DeProjektassistenzRoute = DeProjektassistenzRouteImport.update({
            id: '/de/projektassistenz',path: '/de/projektassistenz',getParentRoute: () => rootRouteImport
          })
const DeProjektleitungRoute = DeProjektleitungRouteImport.update({
            id: '/de/projektleitung',path: '/de/projektleitung',getParentRoute: () => rootRouteImport
          })
const DeProjektoekonomieRoute = DeProjektoekonomieRouteImport.update({
            id: '/de/projektoekonomie',path: '/de/projektoekonomie',getParentRoute: () => rootRouteImport
          })
const DeShutdownPlanungRoute = DeShutdownPlanungRouteImport.update({
            id: '/de/shutdown-planung',path: '/de/shutdown-planung',getParentRoute: () => rootRouteImport
          })
const DeTerminplanungRoute = DeTerminplanungRouteImport.update({
            id: '/de/terminplanung',path: '/de/terminplanung',getParentRoute: () => rootRouteImport
          })
const DeUberUnsRoute = DeUberUnsRouteImport.update({
            id: '/de/uber-uns',path: '/de/uber-uns',getParentRoute: () => rootRouteImport
          })
const EnIndexRoute = EnIndexRouteImport.update({
            id: '/en/',path: '/en/',getParentRoute: () => rootRouteImport
          })
const EnAboutUsRoute = EnAboutUsRouteImport.update({
            id: '/en/about-us',path: '/en/about-us',getParentRoute: () => rootRouteImport
          })
const EnBusinessPartnersRoute = EnBusinessPartnersRouteImport.update({
            id: '/en/business-partners',path: '/en/business-partners',getParentRoute: () => rootRouteImport
          })
const EnCareersRoute = EnCareersRouteImport.update({
            id: '/en/careers',path: '/en/careers',getParentRoute: () => rootRouteImport
          })
const EnClientConsultancyRoute = EnClientConsultancyRouteImport.update({
            id: '/en/client-consultancy',path: '/en/client-consultancy',getParentRoute: () => rootRouteImport
          })
const EnConstructionManagementRoute = EnConstructionManagementRouteImport.update({
            id: '/en/construction-management',path: '/en/construction-management',getParentRoute: () => rootRouteImport
          })
const EnContactMiSupportRoute = EnContactMiSupportRouteImport.update({
            id: '/en/contact-mi-support',path: '/en/contact-mi-support',getParentRoute: () => rootRouteImport
          })
const EnCookieAndPrivacyPolicyRoute = EnCookieAndPrivacyPolicyRouteImport.update({
            id: '/en/cookie-and-privacy-policy',path: '/en/cookie-and-privacy-policy',getParentRoute: () => rootRouteImport
          })
const EnDatapolicyRoute = EnDatapolicyRouteImport.update({
            id: '/en/datapolicy',path: '/en/datapolicy',getParentRoute: () => rootRouteImport
          })
const EnEsgRoute = EnEsgRouteImport.update({
            id: '/en/esg',path: '/en/esg',getParentRoute: () => rootRouteImport
          })
const EnHseManagementRoute = EnHseManagementRouteImport.update({
            id: '/en/hse-management',path: '/en/hse-management',getParentRoute: () => rootRouteImport
          })
const EnMeetAMiSupporterRoute = EnMeetAMiSupporterRouteImport.update({
            id: '/en/meet-a-mi-supporter',path: '/en/meet-a-mi-supporter',getParentRoute: () => rootRouteImport
          })
const EnMeetChristianRoute = EnMeetChristianRouteImport.update({
            id: '/en/meet-christian',path: '/en/meet-christian',getParentRoute: () => rootRouteImport
          })
const EnMeetDanRoute = EnMeetDanRouteImport.update({
            id: '/en/meet-dan',path: '/en/meet-dan',getParentRoute: () => rootRouteImport
          })
const EnMeetDanielRoute = EnMeetDanielRouteImport.update({
            id: '/en/meet-daniel',path: '/en/meet-daniel',getParentRoute: () => rootRouteImport
          })
const EnMeetMaleneRoute = EnMeetMaleneRouteImport.update({
            id: '/en/meet-malene',path: '/en/meet-malene',getParentRoute: () => rootRouteImport
          })
const EnMeetNoreenThomasRoute = EnMeetNoreenThomasRouteImport.update({
            id: '/en/meet-noreen-thomas',path: '/en/meet-noreen-thomas',getParentRoute: () => rootRouteImport
          })
const EnMiSupportAsAWorkplaceRoute = EnMiSupportAsAWorkplaceRouteImport.update({
            id: '/en/mi-support-as-a-workplace',path: '/en/mi-support-as-a-workplace',getParentRoute: () => rootRouteImport
          })
const EnMiSupportLogoRoute = EnMiSupportLogoRouteImport.update({
            id: '/en/mi-support-logo',path: '/en/mi-support-logo',getParentRoute: () => rootRouteImport
          })
const EnMoedEstherRoute = EnMoedEstherRouteImport.update({
            id: '/en/moed-esther',path: '/en/moed-esther',getParentRoute: () => rootRouteImport
          })
const EnMoedMajaRoute = EnMoedMajaRouteImport.update({
            id: '/en/moed-maja',path: '/en/moed-maja',getParentRoute: () => rootRouteImport
          })
const EnMoedTokeRoute = EnMoedTokeRouteImport.update({
            id: '/en/moed-toke',path: '/en/moed-toke',getParentRoute: () => rootRouteImport
          })
const EnProjectAssistanceRoute = EnProjectAssistanceRouteImport.update({
            id: '/en/project-assistance',path: '/en/project-assistance',getParentRoute: () => rootRouteImport
          })
const EnProjectEconomicsRoute = EnProjectEconomicsRouteImport.update({
            id: '/en/project-economics',path: '/en/project-economics',getParentRoute: () => rootRouteImport
          })
const EnProjectManagementRoute = EnProjectManagementRouteImport.update({
            id: '/en/project-management',path: '/en/project-management',getParentRoute: () => rootRouteImport
          })
const EnSchedulingRoute = EnSchedulingRouteImport.update({
            id: '/en/scheduling',path: '/en/scheduling',getParentRoute: () => rootRouteImport
          })
const EnServicesRoute = EnServicesRouteImport.update({
            id: '/en/services',path: '/en/services',getParentRoute: () => rootRouteImport
          })
const EnShutdownPlanningRoute = EnShutdownPlanningRouteImport.update({
            id: '/en/shutdown-planning',path: '/en/shutdown-planning',getParentRoute: () => rootRouteImport
          })
const VidenIndexRoute = VidenIndexRouteImport.update({
            id: '/viden/',path: '/viden/',getParentRoute: () => rootRouteImport
          })
const VidenSlugRoute = VidenSlugRouteImport.update({
            id: '/viden/$slug',path: '/viden/$slug',getParentRoute: () => rootRouteImport
          })
const DeArtikelIndexRoute = DeArtikelIndexRouteImport.update({
            id: '/de/artikel/',path: '/de/artikel/',getParentRoute: () => rootRouteImport
          })
const DeArtikelSlugRoute = DeArtikelSlugRouteImport.update({
            id: '/de/artikel/$slug',path: '/de/artikel/$slug',getParentRoute: () => rootRouteImport
          })
const DeBranchenIndexRoute = DeBranchenIndexRouteImport.update({
            id: '/de/branchen/',path: '/de/branchen/',getParentRoute: () => rootRouteImport
          })
const DeBranchenBuerosHauptsitzeRoute = DeBranchenBuerosHauptsitzeRouteImport.update({
            id: '/de/branchen/bueros-hauptsitze',path: '/de/branchen/bueros-hauptsitze',getParentRoute: () => rootRouteImport
          })
const DeBranchenEnergieInfrastrukturRoute = DeBranchenEnergieInfrastrukturRouteImport.update({
            id: '/de/branchen/energie-infrastruktur',path: '/de/branchen/energie-infrastruktur',getParentRoute: () => rootRouteImport
          })
const DeBranchenIndustrieProduktionRoute = DeBranchenIndustrieProduktionRouteImport.update({
            id: '/de/branchen/industrie-produktion',path: '/de/branchen/industrie-produktion',getParentRoute: () => rootRouteImport
          })
const DeBranchenKrankenhaeuserGesundheitRoute = DeBranchenKrankenhaeuserGesundheitRouteImport.update({
            id: '/de/branchen/krankenhaeuser-gesundheit',path: '/de/branchen/krankenhaeuser-gesundheit',getParentRoute: () => rootRouteImport
          })
const DeBranchenPharmaLifeScienceRoute = DeBranchenPharmaLifeScienceRouteImport.update({
            id: '/de/branchen/pharma-life-science',path: '/de/branchen/pharma-life-science',getParentRoute: () => rootRouteImport
          })
const DeBranchenRechenzentrenRoute = DeBranchenRechenzentrenRouteImport.update({
            id: '/de/branchen/rechenzentren',path: '/de/branchen/rechenzentren',getParentRoute: () => rootRouteImport
          })
const DeBranchenTransportLogistikRoute = DeBranchenTransportLogistikRouteImport.update({
            id: '/de/branchen/transport-logistik',path: '/de/branchen/transport-logistik',getParentRoute: () => rootRouteImport
          })
const EnArticlesIndexRoute = EnArticlesIndexRouteImport.update({
            id: '/en/articles/',path: '/en/articles/',getParentRoute: () => rootRouteImport
          })
const EnArticlesSlugRoute = EnArticlesSlugRouteImport.update({
            id: '/en/articles/$slug',path: '/en/articles/$slug',getParentRoute: () => rootRouteImport
          })
const EnIndustriesIndexRoute = EnIndustriesIndexRouteImport.update({
            id: '/en/industries/',path: '/en/industries/',getParentRoute: () => rootRouteImport
          })
const EnIndustriesDataCentersRoute = EnIndustriesDataCentersRouteImport.update({
            id: '/en/industries/data-centers',path: '/en/industries/data-centers',getParentRoute: () => rootRouteImport
          })
const EnIndustriesEnergyInfrastructureRoute = EnIndustriesEnergyInfrastructureRouteImport.update({
            id: '/en/industries/energy-infrastructure',path: '/en/industries/energy-infrastructure',getParentRoute: () => rootRouteImport
          })
const EnIndustriesHospitalsHealthcareRoute = EnIndustriesHospitalsHealthcareRouteImport.update({
            id: '/en/industries/hospitals-healthcare',path: '/en/industries/hospitals-healthcare',getParentRoute: () => rootRouteImport
          })
const EnIndustriesIndustryManufacturingRoute = EnIndustriesIndustryManufacturingRouteImport.update({
            id: '/en/industries/industry-manufacturing',path: '/en/industries/industry-manufacturing',getParentRoute: () => rootRouteImport
          })
const EnIndustriesOfficesHeadquartersRoute = EnIndustriesOfficesHeadquartersRouteImport.update({
            id: '/en/industries/offices-headquarters',path: '/en/industries/offices-headquarters',getParentRoute: () => rootRouteImport
          })
const EnIndustriesPharmaLifeScienceRoute = EnIndustriesPharmaLifeScienceRouteImport.update({
            id: '/en/industries/pharma-life-science',path: '/en/industries/pharma-life-science',getParentRoute: () => rootRouteImport
          })
const EnIndustriesTransportLogisticsRoute = EnIndustriesTransportLogisticsRouteImport.update({
            id: '/en/industries/transport-logistics',path: '/en/industries/transport-logistics',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AnalyticsRoute: AnalyticsRoute,ByggeledelseRoute: ByggeledelseRoute,BygherreraadgivningRoute: BygherreraadgivningRoute,CookieOgPrivatlivspolitikRoute: CookieOgPrivatlivspolitikRoute,EsgRoute: EsgRoute,GratisSikkerhedstjekLandingRoute: GratisSikkerhedstjekLandingRoute,HseLedelseRoute: HseLedelseRoute,KarriereRoute: KarriereRoute,KontaktRoute: KontaktRoute,KontaktMiSupportRoute: KontaktMiSupportRoute,MiSupportLogoRoute: MiSupportLogoRoute,MiSupportSomArbejdspladsRoute: MiSupportSomArbejdspladsRoute,ModDanRoute: ModDanRoute,ModDanielRoute: ModDanielRoute,ModEnMiSupporterRoute: ModEnMiSupporterRoute,ModMaleneRoute: ModMaleneRoute,ModNoreenThomasRoute: ModNoreenThomasRoute,MoedChristianRoute: MoedChristianRoute,MoedEstherRoute: MoedEstherRoute,MoedMajaRoute: MoedMajaRoute,MoedTokeRoute: MoedTokeRoute,OmOsRoute: OmOsRoute,PersondatapolitikRoute: PersondatapolitikRoute,ProjektassistanceRoute: ProjektassistanceRoute,ProjektledelseRoute: ProjektledelseRoute,ProjektoekonomiRoute: ProjektoekonomiRoute,SamarbejdspartnereRoute: SamarbejdspartnereRoute,ShutdownPlanlaegningRoute: ShutdownPlanlaegningRoute,SikkerhedsledelseHseRoute: SikkerhedsledelseHseRoute,SitecomplianceRoute: SitecomplianceRoute,TidsplanlaegningRoute: TidsplanlaegningRoute,YdelserRoute: YdelserRoute,ArtiklerSlugRoute: ArtiklerSlugRoute,BrancherDatacentreRoute: BrancherDatacentreRoute,BrancherEnergiInfrastrukturRoute: BrancherEnergiInfrastrukturRoute,BrancherHospitalerSundhedRoute: BrancherHospitalerSundhedRoute,BrancherIndustriProduktionRoute: BrancherIndustriProduktionRoute,BrancherKontorHovedsaederRoute: BrancherKontorHovedsaederRoute,BrancherPharmaLifeScienceRoute: BrancherPharmaLifeScienceRoute,BrancherTransportLogistikRoute: BrancherTransportLogistikRoute,DeBauherrenberatungRoute: DeBauherrenberatungRoute,DeBaumanagementRoute: DeBaumanagementRoute,DeCookieUndDatenschutzrichtlinieRoute: DeCookieUndDatenschutzrichtlinieRoute,DeDatenschutzbestimmungenRoute: DeDatenschutzbestimmungenRoute,DeEsgRoute: DeEsgRoute,DeGegenDieseRoute: DeGegenDieseRoute,DeGegenNoreenThomasRoute: DeGegenNoreenThomasRoute,DeGegenuberDanielRoute: DeGegenuberDanielRoute,DeGegenuberEinemMitstreiterRoute: DeGegenuberEinemMitstreiterRoute,DeGegenuberMaleneRoute: DeGegenuberMaleneRoute,DeGeschaftspartnerRoute: DeGeschaftspartnerRoute,DeHseManagementRoute: DeHseManagementRoute,DeKarriereRoute: DeKarriereRoute,DeKontaktMiSupportRoute: DeKontaktMiSupportRoute,DeLeistungenRoute: DeLeistungenRoute,DeMiSupportLogoRoute: DeMiSupportLogoRoute,DeMiUnterstutzungAlsArbeitsplatzRoute: DeMiUnterstutzungAlsArbeitsplatzRoute,DeMoedEstherRoute: DeMoedEstherRoute,DeMoedMajaRoute: DeMoedMajaRoute,DeMoedTokeRoute: DeMoedTokeRoute,DeMutigerChristRoute: DeMutigerChristRoute,DeProjektassistenzRoute: DeProjektassistenzRoute,DeProjektleitungRoute: DeProjektleitungRoute,DeProjektoekonomieRoute: DeProjektoekonomieRoute,DeShutdownPlanungRoute: DeShutdownPlanungRoute,DeTerminplanungRoute: DeTerminplanungRoute,DeUberUnsRoute: DeUberUnsRoute,EnAboutUsRoute: EnAboutUsRoute,EnBusinessPartnersRoute: EnBusinessPartnersRoute,EnCareersRoute: EnCareersRoute,EnClientConsultancyRoute: EnClientConsultancyRoute,EnConstructionManagementRoute: EnConstructionManagementRoute,EnContactMiSupportRoute: EnContactMiSupportRoute,EnCookieAndPrivacyPolicyRoute: EnCookieAndPrivacyPolicyRoute,EnDatapolicyRoute: EnDatapolicyRoute,EnEsgRoute: EnEsgRoute,EnHseManagementRoute: EnHseManagementRoute,EnMeetAMiSupporterRoute: EnMeetAMiSupporterRoute,EnMeetChristianRoute: EnMeetChristianRoute,EnMeetDanRoute: EnMeetDanRoute,EnMeetDanielRoute: EnMeetDanielRoute,EnMeetMaleneRoute: EnMeetMaleneRoute,EnMeetNoreenThomasRoute: EnMeetNoreenThomasRoute,EnMiSupportAsAWorkplaceRoute: EnMiSupportAsAWorkplaceRoute,EnMiSupportLogoRoute: EnMiSupportLogoRoute,EnMoedEstherRoute: EnMoedEstherRoute,EnMoedMajaRoute: EnMoedMajaRoute,EnMoedTokeRoute: EnMoedTokeRoute,EnProjectAssistanceRoute: EnProjectAssistanceRoute,EnProjectEconomicsRoute: EnProjectEconomicsRoute,EnProjectManagementRoute: EnProjectManagementRoute,EnSchedulingRoute: EnSchedulingRoute,EnServicesRoute: EnServicesRoute,EnShutdownPlanningRoute: EnShutdownPlanningRoute,VidenSlugRoute: VidenSlugRoute,ArtiklerIndexRoute: ArtiklerIndexRoute,BrancherIndexRoute: BrancherIndexRoute,DeIndexRoute: DeIndexRoute,EnIndexRoute: EnIndexRoute,VidenIndexRoute: VidenIndexRoute,DeArtikelSlugRoute: DeArtikelSlugRoute,DeBranchenBuerosHauptsitzeRoute: DeBranchenBuerosHauptsitzeRoute,DeBranchenEnergieInfrastrukturRoute: DeBranchenEnergieInfrastrukturRoute,DeBranchenIndustrieProduktionRoute: DeBranchenIndustrieProduktionRoute,DeBranchenKrankenhaeuserGesundheitRoute: DeBranchenKrankenhaeuserGesundheitRoute,DeBranchenPharmaLifeScienceRoute: DeBranchenPharmaLifeScienceRoute,DeBranchenRechenzentrenRoute: DeBranchenRechenzentrenRoute,DeBranchenTransportLogistikRoute: DeBranchenTransportLogistikRoute,EnArticlesSlugRoute: EnArticlesSlugRoute,EnIndustriesDataCentersRoute: EnIndustriesDataCentersRoute,EnIndustriesEnergyInfrastructureRoute: EnIndustriesEnergyInfrastructureRoute,EnIndustriesHospitalsHealthcareRoute: EnIndustriesHospitalsHealthcareRoute,EnIndustriesIndustryManufacturingRoute: EnIndustriesIndustryManufacturingRoute,EnIndustriesOfficesHeadquartersRoute: EnIndustriesOfficesHeadquartersRoute,EnIndustriesPharmaLifeScienceRoute: EnIndustriesPharmaLifeScienceRoute,EnIndustriesTransportLogisticsRoute: EnIndustriesTransportLogisticsRoute,DeArtikelIndexRoute: DeArtikelIndexRoute,DeBranchenIndexRoute: DeBranchenIndexRoute,EnArticlesIndexRoute: EnArticlesIndexRoute,EnIndustriesIndexRoute: EnIndustriesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)